// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iO","advertCardNum":"c-a_iP"};